export default __webpack_public_path__ + "static/media/image 10.e4416c86.png";